import { css } from '@emotion/css';

const container = css`
  font-family: $fontFamily;
  position: relative;
`;
const content = css`
  position: relative;
`;

const subTitle = css`
  font-size: 15px;
`;
const header = css`
  background: #ebf3fa;
  padding: 20px 30px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

const boxTitle = css`
  font-weight: 600;
  font-size: 28px;
  color: #000;
  margin-bottom: 15px;

  @media (max-width: 992px) {
    font-size: 20px;
  }
`;

const CredentialsStyles = {
  container,
  content,
  subTitle,
  header,
  boxTitle,
};

export default CredentialsStyles;
